'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentDayMidnight = exports.DateRanges = exports.getDateRangeFromToday = undefined;

var _moment = require('@fr/moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A bunch of Date utilities.
 */

/**
 * Returns a value for the date ranges
 *
 * @param {string} date The date to check in the format YYYY-MM-DD.
 *
 * @return {integer} Returns an integer based on the Enum 'DateRanges', which 
 *                   can be used to check the date range.
 */
var getDateRangeFromToday = exports.getDateRangeFromToday = function getDateRangeFromToday(date) {
  // Use moment strict mode to ensure we're using the correct format.
  // See: https://momentjs.com/guides/#/parsing/strict-mode/.
  var mmtDate = (0, _moment2.default)(date, 'YYYY-MM-DD', true).startOf('day');

  if (!mmtDate.isValid()) {
    throw new Error('\'' + date + '\' is not a valid date, please use a string in the format YYYY-MM-DD.');
  }

  if (mmtDate) {
    var mmt3DaysAgo = getCurrentDayMidnight().subtract(3, 'days'),
        mmt2DaysAgo = getCurrentDayMidnight().subtract(2, 'days'),
        mmt1DayAgo = getCurrentDayMidnight().subtract(1, 'days'),
        mmt1DayAhead = getCurrentDayMidnight().add(1, 'days'),
        mmt14DaysAhead = getCurrentDayMidnight().add(14, 'days');

    if (mmtDate.isBefore(mmt3DaysAgo)) {
      return DateRanges.OVER_3_DAYS_PAST;
    } else if (getCurrentDayMidnight().format('YYYY-MM-DD') === mmtDate.format('YYYY-MM-DD')) {
      return DateRanges.TODAY;
    } else if (mmtDate.isSameOrAfter(mmt1DayAhead) && mmtDate.isSameOrBefore(mmt14DaysAhead)) {
      return DateRanges.BETWEEN_1_AND_14_DAYS_AHEAD;
    } else if (mmtDate.isAfter(mmt14DaysAhead)) {
      return DateRanges.OVER_14_DAYS_AHEAD;
    } else if (mmtDate.isSameOrAfter(mmt3DaysAgo), mmtDate.isBefore(mmt2DaysAgo)) {
      return DateRanges.THREE_DAYS_IN_THE_PAST;
    } else if (mmtDate.isSameOrAfter(mmt2DaysAgo) && mmtDate.isBefore(mmt1DayAgo)) {
      return DateRanges.TWO_DAYS_IN_THE_PAST;
    } else if (mmtDate.isSameOrAfter(mmt1DayAgo) && mmtDate.isSameOrBefore(mmtDate.format('YYYY-MM-DD'))) {
      return DateRanges.ONE_DAY_IN_THE_PAST;
    }
  }
};

/**
 * Enum for Date ranges. Can be imported to compare the value returned in 
 * 'departureDateRange' function.
 */
var DateRanges = exports.DateRanges = {
  OVER_3_DAYS_PAST: 0,
  ONE_DAY_IN_THE_PAST: 1,
  TWO_DAYS_IN_THE_PAST: 2,
  THREE_DAYS_IN_THE_PAST: 3,
  TODAY: 4,
  BETWEEN_1_AND_14_DAYS_AHEAD: 5,
  OVER_14_DAYS_AHEAD: 6
};

var getCurrentDayMidnight = exports.getCurrentDayMidnight = function getCurrentDayMidnight() {
  return (0, _moment2.default)().startOf('day');
};